import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Menu } from "@headlessui/react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

import type { ExportFormat } from "./exportDetails";
import { smallButton } from "./smallButton";

/** "Export data" menu: CSV or PDF; disabled while a download is prepared. */
const ExportMenu: FunctionComponent<{
  onExport: (format: ExportFormat) => Promise<void>;
}> = ({ onExport }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const run = async (format: ExportFormat) => {
    setBusy(true);
    try {
      await onExport(format);
    } finally {
      setBusy(false);
    }
  };
  const formats: { format: ExportFormat; label: string }[] = [
    { format: "csv", label: t("profile.export_csv") },
    { format: "pdf", label: t("profile.export_pdf") },
  ];

  return (
    <Menu as="div" className="relative">
      <Menu.Button className={`btn-default ${smallButton}`} disabled={busy}>
        <ArrowDownTrayIcon className="h-3.5 w-3.5" aria-hidden="true" />
        {t("profile.export")}
      </Menu.Button>
      <Menu.Items className="absolute left-0 z-10 mt-1 w-40 rounded-lg border border-gray-200 bg-white py-1 shadow-lg focus:outline-none">
        {formats.map(({ format, label }) => (
          <Menu.Item key={format}>
            {({ active }) => (
              <button
                type="button"
                className={classNames(
                  "block w-full px-4 py-2 text-left text-sm text-gray-900",
                  { "bg-gray-50": active },
                )}
                onClick={() => run(format)}
              >
                {label}
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
};

export default ExportMenu;
